import { render, staticRenderFns } from "./ListCards.vue?vue&type=template&id=01cb38ba&scoped=true"
import script from "./ListCards.vue?vue&type=script&lang=js"
export * from "./ListCards.vue?vue&type=script&lang=js"
import style0 from "./ListCards.vue?vue&type=style&index=0&id=01cb38ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb38ba",
  null
  
)

export default component.exports